import React from "react";
import { yellow, green, deepPurple, lightBlue } from "@mui/material/colors";
import Tooltip from "@mui/material/Tooltip";

function SantaIconSmall({ size = 20 }) {
  return (
    <span
      role="img"
      aria-label="Santa"
      style={{ fontSize: size, lineHeight: 1, display: 'inline-block' }}
    >
      🎅
    </span>
  );
}

export const deliveryColors = {
  NOT_DELIVERED: '#666666',           // same as now
  MARKED_AS_DELIVERED: yellow[700],     // yellow 500
  DELIVERY_CONFIRMED: green[500],      // green 500
  DELIVERY_DOUBLE_CHECKED: deepPurple[500], // deep purple 400 (violet)
  NOTIFICATION_SENT: lightBlue[500]        // blue 500
};

export default function SantasStatusCounts({ santasCountByStatus, santasCount, style, separatorColor = '#666' }) {
  const order = [
    'NOT_DELIVERED',
    'MARKED_AS_DELIVERED',
    'DELIVERY_CONFIRMED',
    'DELIVERY_DOUBLE_CHECKED',
    'NOTIFICATION_SENT'
  ];

  const labels = {
    NOT_DELIVERED: 'Not delivered',
    MARKED_AS_DELIVERED: 'Marked as delivered',
    DELIVERY_CONFIRMED: 'Delivery confirmed',
    DELIVERY_DOUBLE_CHECKED: 'Delivery double-checked',
    NOTIFICATION_SENT: 'Notification sent'
  };

  let obj = {};
  try {
    if (santasCountByStatus) {
      const parsed = typeof santasCountByStatus === 'string'
        ? JSON.parse(santasCountByStatus)
        : santasCountByStatus;
      if (parsed && typeof parsed === 'object') obj = parsed;
    }
  } catch (_) { /* ignore parse error */
  }

  const notifSent = (() => {
    const n = Number(obj?.NOTIFICATION_SENT);
    return Number.isFinite(n) ? n : 0;
  })();

  const totalCount = (() => {
    const n = Number(santasCount);
    return Number.isFinite(n) ? n : 0;
  })();

  const showAllSent = totalCount !== 0 && notifSent === totalCount;

  return (
    <div style={{ fontSize: '1em', color: '#666', display: 'inline-flex', alignItems: 'center', gap: 6, ...(style || {}) }}>
      {order.map((k, idx) => (
        <React.Fragment key={k}>
          <Tooltip title={labels[k] || k} arrow>
            <span style={{ color: deliveryColors[k] }}>{obj?.[k] ?? 0}</span>
          </Tooltip>
          {idx < order.length - 1 && <span style={{ color: separatorColor }}>/</span>}
        </React.Fragment>
      ))}
      {showAllSent && (
        <Tooltip title={"Santas job completed!"}>
          <span>
            <SantaIconSmall />
          </span>
        </Tooltip>
      )}
    </div>
  );
}
